module.exports = __webpack_public_path__ + "static/media/argentina.86bd87d5.svg";